export default __webpack_public_path__ + "static/media/replace-battery-selected.a6770491.svg";